import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import RhapStatusSelect from '~/components/common/RhapStatusSelect'
import { LabStatusToColorVariant } from '~/constants/colors'
import { getLabTestsStates } from '~/store/reducers/constants'

export interface LabStatusSelectProps {
  onChange?: (newValue: string) => void
  value?: string
}

const LabStatusSelect = ({ value, onChange }: LabStatusSelectProps) => {
  const { t } = useTranslation()
  const options = useSelector(getLabTestsStates)

  return (
    <RhapStatusSelect
      colorMap={LabStatusToColorVariant}
      getOptionId={(option) => option.id}
      getOptionName={(option) => option.name}
      label={t('Common:LAB_TEST_STATUS')}
      options={options}
      value={value}
      onChange={onChange}
    />
  )
}

export default LabStatusSelect
